import React, { FC } from "react";
import "./DrawerBars.scss";

export interface Props {
  tabIndex?: string;
  /**
   * Number of bars for the button, defaults to 2
   */
  bars?: number;
  onToggle(): void;
}

const DrawerBars: FC<Props> = props => {

  let { bars } = props;

  // 0 is not a valid number of bars so a simple truthy check works here
  if (!bars) {
    bars = 2;
  }

  function getBars() {

    const barElements = []

    for (let bar = 0; bar < bars; bar++) {
      barElements.push(<div key={`drawer-bar-${bar}`} className={`drawer-bar bar${bar}`} />);
    }

    return barElements;
  }

  return (
    <button className="drawer-bars" tabIndex={props.tabIndex ? Number(props.tabIndex) : 0} aria-label={"open menu"} aria-hidden={false} onClick={props.onToggle}>
      {getBars()}
    </button>
  );
};

export default DrawerBars;
